import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, setBlockTracking as _setBlockTracking, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = { class: "ticks-container top-left fill-block" }
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScrollUpIcon = _resolveComponent("ScrollUpIcon")!
  const _component_ScrollDownIcon = _resolveComponent("ScrollDownIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["scroller", {
      'scrolling-recycler-now': _ctx.scrollingRecyclerNowTimer,
      'scrolling-recycler': _ctx.scrollingRecyclerTimer,
      'scrolling-now': _ctx.scrollingNowTimer,
      scrolling: _ctx.scrollingTimer,
    }]),
    ref: "scroller",
    onMousemovePassive: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.mousemove && _ctx.mousemove(...args))),
    onMouseleavePassive: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.mouseleave && _ctx.mouseleave(...args))),
    onMousedownPassive: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.mousedown && _ctx.mousedown(...args))),
    onMouseupPassive: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.interactend && _ctx.interactend(...args))),
    onTouchmove: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.touchmove && _ctx.touchmove(...args)), ["prevent"])),
    onTouchstartPassive: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.interactstart && _ctx.interactstart(...args))),
    onTouchendPassive: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.interactend && _ctx.interactend(...args))),
    onTouchcancelPassive: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.interactend && _ctx.interactend(...args)))
  }, [
    _createElementVNode("span", {
      class: "cursor st",
      ref: "cursorSt",
      style: _normalizeStyle({ transform: `translateY(${_ctx.cursorY}px)` })
    }, null, 4),
    _createElementVNode("span", {
      ref: "hoverCursor",
      class: "cursor hv",
      style: _normalizeStyle({ transform: _ctx.hoverCursorTransform }),
      onTouchmove: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.touchmove && _ctx.touchmove(...args)), ["prevent"])),
      onTouchstartPassive: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.interactstart && _ctx.interactstart(...args))),
      onTouchendPassive: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.interactend && _ctx.interactend(...args))),
      onTouchcancelPassive: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.interactend && _ctx.interactend(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.hoverCursorText), 1),
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (
          _setBlockTracking(-1, true),
          (_cache[0] = _createVNode(_component_ScrollUpIcon, { size: 22 })).cacheIndex = 0,
          _setBlockTracking(1),
          _cache[0]
        ),
        _cache[1] || (
          _setBlockTracking(-1, true),
          (_cache[1] = _createVNode(_component_ScrollDownIcon, { size: 22 })).cacheIndex = 1,
          _setBlockTracking(1),
          _cache[1]
        )
      ])
    ], 36),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTicks, (tick) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tick.key,
          class: "tick",
          style: _normalizeStyle({ transform: `translateY(calc(${tick.top}px - 50%))` })
        }, [
          (tick.text)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(tick.text), 1))
            : _createCommentVNode("", true)
        ], 4))
      }), 128))
    ])
  ], 34))
}